import React from 'react';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';

const WantToBePart = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/como-ajudar');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
       <div className='section-separator'>
        <Container className='px-4 text-center about-us-font'>
            <div className='p-5'>
                <h2 className='display-5 fw-bold text-white about-us-font'>QUERES FAZER PARTE DESTA MUDANÇA?</h2>
                <div className='col-lg-5 mx-auto'>
                    <p className='mb-4 about-us-text'>Descobre como te podes envolver connosco!</p>
                    <div>
                        <button type='button' className='main-btn fw-bold' onClick={handleClick}>
                            Ver Contactos
                        </button>
                    </div>
                </div>
                
            </div>
        </Container>
            
    </div>
    );
}

export default WantToBePart;